import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { SOCIAL_NETWORKS } from '../../../../../widget/constants/social-networks';
import { buildImageUrl } from '../utils';
import { buildUrl } from '../../../../../common/utils/url/build-url';
import { openPopup } from '../../../../../common/utils/open-popup';
import { Tooltip } from '../../../../tooltip/tooltip';
import { InlineIcon } from '../../../../inline-icon/inline-icon';
import parentStyles from '../styles.scss';
import TumblrIcon from '../../../../../icons/compiled/components/TumblrIcon';
export class Tumblr extends React.Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { siteUrl } = this.props.instanceInfo;
            const { descriptionText, canShareContent, content } = this.props;
            if (canShareContent) {
                const url = buildUrl('https://www.tumblr.com/widgets/share/tool', {
                    posttype: 'photo',
                    // todo: need to find a way to resize image for tumblr
                    content: buildImageUrl(content.coverUrl),
                    caption: descriptionText
                        .replace('{siteUrl}', siteUrl)
                        .replace('{title}', content.title),
                    url: siteUrl,
                });
                openPopup(url);
            }
            this.props.onShare(SOCIAL_NETWORKS.TUMBLR);
        };
    }
    render() {
        const { className, dataHook, ariaLabel, tooltip } = this.props;
        return (React.createElement(Tooltip, { content: tooltip },
            React.createElement("button", { onClick: this.onClick, "data-hook": dataHook, className: className, "aria-label": ariaLabel },
                React.createElement(InlineIcon, { icon: React.createElement(TumblrIcon, null), className: parentStyles.icon }))));
    }
}
Tumblr.propTypes = {
    dataHook: PropTypes.string,
    onShare: PropTypes.func,
    content: PropTypes.object,
    className: PropTypes.string,
    descriptionText: PropTypes.string,
    tooltip: PropTypes.node,
    canShareContent: PropTypes.bool,
    ariaLabel: PropTypes.string,
    instanceInfo: PropTypes.shape({
        instanceId: PropTypes.string,
        componentId: PropTypes.string,
        sitePageId: PropTypes.string,
        siteUrl: PropTypes.string,
    }),
};
Tumblr.defaultProps = {
    onShare: noop,
};
//# sourceMappingURL=tumblr.js.map